import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopoverPlacement } from 'ngx-smart-popover';
import { Color } from '../../../constants/color.constants';
import { TabsConfig } from '../../../models/common';

@Component({
    selector: 'tabs',
    styleUrls: ['./tabs.component.scss'],
    template: `
        <div class="tabs">
            <ng-container *ngFor="let tab of tabsConfig">
                <a
                    *ngIf="shouldUseRouting"
                    [routerLink]="tab.routerLink"
                    routerLinkActive="selected"
                    [queryParamsHandling]="tab.queryParamHandling"
                    [queryParams]="tab.queryParams"
                    class="tab"
                    (click)="handleTabClick(tab.label)"
                >
                    {{ tab.label }}
                    <lsq-icon
                        *ngIf="tab.icon && tab.iconPopoverText"
                        [height]="tab.iconSize || 10"
                        [width]="tab.iconSize || 10"
                        [type]="tab.icon"
                        [color]="tab.iconColor"
                        [popover]="tab.iconPopoverText"
                        [popoverPlacement]="popoverPlacement"
                        [style.marginLeft]="'0.5rem'"
                    ></lsq-icon>
                    <lsq-icon
                        *ngIf="tab.icon && !tab.iconPopoverText"
                        [height]="tab.iconSize || 10"
                        [width]="tab.iconSize || 10"
                        [color]="tab.iconColor"
                        [type]="tab.icon"
                        [style.marginLeft]="'0.5rem'"
                    ></lsq-icon>
                    <span
                        *ngIf="tab.counter && tab.counter > 0"
                        [style.background]="tab.counterBgColor ?? color.Red"
                        [style.color]="tab.counterColor ?? color.White"
                        [style.marginLeft]="'0.5rem'"
                        class="tab-counter"
                    >
                        {{ tab.counter }}
                    </span>
                </a>

                <a
                    *ngIf="!shouldUseRouting"
                    [ngClass]="{
                        selected: selectedTab === tab.label
                    }"
                    class="tab"
                    (click)="handleTabClick(tab.label)"
                >
                    {{ tab.label }}
                    <lsq-icon
                        *ngIf="tab.icon && tab.iconPopoverText"
                        [height]="tab.iconSize || 10"
                        [width]="tab.iconSize || 10"
                        [type]="tab.icon"
                        [color]="tab.iconColor"
                        [popover]="tab.iconPopoverText"
                        [popoverPlacement]="popoverPlacement"
                        [style.marginLeft]="'0.5rem'"
                    ></lsq-icon>
                    <lsq-icon
                        *ngIf="tab.icon && !tab.iconPopoverText"
                        [height]="tab.iconSize || 10"
                        [width]="tab.iconSize || 10"
                        [color]="tab.iconColor"
                        [type]="tab.icon"
                        [style.marginLeft]="'0.5rem'"
                    ></lsq-icon>
                    <span
                        *ngIf="tab.counter && tab.counter > 0"
                        [style.background]="tab.counterBgColor ?? color.Red"
                        [style.color]="tab.counterColor ?? color.White"
                        [style.marginLeft]="'0.5rem'"
                        class="tab-counter"
                    >
                        {{ tab.counter }}
                    </span>
                </a>
            </ng-container>
        </div>
    `
})
export class TabsComponent {
    @Input() public tabsConfig: TabsConfig[];
    @Input() public shouldUseRouting = true;
    @Output() public tabClick = new EventEmitter<string>();

    public color = Color;
    public selectedTab = '';
    public popoverPlacement = PopoverPlacement.Top;

    public ngOnInit(): void {
        if (!this.shouldUseRouting && this.tabsConfig.length) {
            this.handleTabClick(this.tabsConfig[0].label);
        }
    }

    public handleTabClick(label: string): void {
        this.selectedTab = label;
        this.tabClick.emit(label);
    }
}
